import * as React from 'react';
import styles from './index.less';
import wrapStore from '@src/utils/wrap-store';
import WelfareSectionStore from '@src/pages/main/components/welfare-section/store';
import Link from '@src/components/link';
import cx from 'classnames';
import BaseSwiper from '@src/components/swiper/base-swiper';
import BackgroundImage from '@src/components/background-image';

const WelfareSection = ({ store }) => {
  store.use();

  // 将数组按每组4个进行分组
  const groupItems = (items, groupSize = 4) => {
    const groups = [];
    for (let i = 0; i < items.length; i += groupSize) {
      groups.push(items.slice(i, i + groupSize));
    }
    return groups;
  };

  const fashionGroups = groupItems(store.fashionImgList);
  const reproductionGroups = groupItems(store.reproductionList);

  return (
    <div className={cx(styles.welfarePartRoot, store.isActive && styles.currentPage)}>
      <div className={styles.title} />
      <div className={styles.content}>
        <div className={styles.tabList}>
          {store.tabList.map((item, index) => {
            return (
              <Link key={index} className={cx(styles.tab, store.tabIndex === index && styles.active)} onClick={() => store.clickTab(index)}>
                {item.name}
              </Link>
            );
          })}
        </div>
        <div className={styles.partContent}>
          {/* 福利 */}
          <div className={cx(styles.welfareContent, store.tabIndex === 0 && styles.fashionAct)}>
            <BaseSwiper store={store.welfareSwiper}>
              {store.welfareList.map((item, index) => {
                return (
                  <div key={index} className={styles.welfareSwiperImg}>
                    <img src={item.img} />
                  </div>
                );
              })}
            </BaseSwiper>
          </div>
          {/* 切换按钮 */}
          {store.tabIndex !== 2 && (
            <React.Fragment>
              <Link className={cx(styles.iconLeft, store.tabIndex === 1 && styles.iconLeftAct)} onClick={() => store.clickFashionPrev()} />
              <Link className={cx(styles.iconRight, store.tabIndex === 1 && styles.iconRightAct)} onClick={() => store.clickFashionNext()} />
            </React.Fragment>
          )}

          <div className={cx(styles.fashionContent, store.tabIndex === 1 && styles.act)}>
            {/* 新时装  复刻时装*/}
            <div className={styles.fashionTabList}>
              <div className={cx(styles.tabItem, store.fashionImgIndex === 0 && styles.tabAct)} onClick={() => store.clickFashionTab(0)} />
              <div className={cx(styles.tabItem2, store.fashionImgIndex === 1 && styles.tabAct2)} onClick={() => store.clickFashionTab(1)} />
            </div>

            <div className={cx(styles.fashionContentSwiper, store.fashionImgIndex === 0 && store.tabIndex === 1 && styles.fashionAct)}>
              {/* 新时装 - 分组展示 */}
              <BaseSwiper store={store.fashionSwiper}>
                {fashionGroups.map((group, groupIndex) => (
                  <div key={groupIndex} className={cx(styles.fashionGroup, group.length < 4 && styles.fashionGroupCenter)}>
                    {group.map((item, index) => (
                      <div className={cx(styles.fashionItem)} key={index}>
                        <img src={item.img} />
                        <div className={styles.fashionItemIcon} />
                      </div>
                    ))}
                  </div>
                ))}
              </BaseSwiper>
            </div>

            {/* 复刻时装 - 分组展示 */}
            <div className={cx(styles.fashionContentSwiper, store.fashionImgIndex === 1 && store.tabIndex === 1 && styles.fashionAct)}>
              <div className={styles.reproductionContent}>
                <BaseSwiper store={store.reproductionSwiper}>
                  {store.reproductionList.map((item, index) => {
                    return (
                      <div key={index} className={styles.reproductionSwiperImg}>
                        <img src={item.img} />
                      </div>
                    );
                  })}
                </BaseSwiper>
              </div>

              {/* <BaseSwiper store={store.reproductionSwiper}>
                {reproductionGroups.map((group, groupIndex) => (
                  <div key={groupIndex} className={cx(styles.fashionGroup, group.length < 4 && styles.fashionGroupCenter)}>
                    {group.map((item, index) => (
                      <div key={index} className={cx(styles.fashionItem)}>
                        <img src={item.img} />
                      </div>
                    ))}
                  </div>
                ))}
              </BaseSwiper> */}
            </div>
          </div>

          {/* 活动 */}
          <div className={cx(styles.activityContent, store.tabIndex === 2 && styles.fashionAct)}>
            {store.activityImgList.map((item, index) => {
              return (
                <div key={index} className={styles.activityItem}>
                  <img src={item.img} />
                  <div className={styles.activityItemIcon} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default wrapStore(WelfareSection, WelfareSectionStore);
